import { useLanguage } from "../hooks/useLanguage";
import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES } from "../i18n/types";

export function LanguageSwitcher({ className }: { className?: string }) {
	const { currentLanguage, setLanguage, isSyncing } = useLanguage();

	return (
		<div className={className}>
			<div className="flex items-center gap-2">
				{SUPPORTED_LANGUAGES.map((lang) => (
					<button
						key={lang}
						type="button"
						onClick={() => setLanguage(lang)}
						disabled={isSyncing}
						aria-current={currentLanguage === lang ? "true" : undefined}
						className={[
							"font-ui text-[10px] uppercase tracking-widest transition-colors",
							currentLanguage === lang
								? "text-ink"
								: "text-ink/30 hover:text-ink/60",
						].join(" ")}
					>
						{LANGUAGE_LABELS[lang]}
					</button>
				))}
			</div>
		</div>
	);
}
